<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <!-- Filter bar — dùng lại component giống OrderList -->
          <hpo-filter
            :showCompleted="true"
            :orderbutton="true"
            :listStatus="listStatus"
            :headers="filter_headers"
            :viewName="viewName"
            :orderSummary="orderSummary"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>

          <div class="oi-hashtag-summary pb-5 px-5 row">
            <div class="oi-hashtag-summary__header pr-2">
              <v-btn small color="green" outlined rounded @click="dialogUpdate = true" v-if="selectedRows.length > 0 && (adminRole || managerRole || paymentRole)">
                <v-icon left>
                  fa-edit
                </v-icon>
                Cập nhật
              </v-btn>
            </div>
            <div class="oi-hashtag-summary__header">
              <v-btn small color="primary" outlined rounded @click="openHashtagDialog">
                <v-icon left>
                  fa-hashtag
                </v-icon>
                HASHTAG
              </v-btn>
              <span v-if="activeHashtagIds.length > 0" class="oi-hashtag-summary__active ml-2">
                Đã chọn {{ activeHashtagIds.length }} tag
              </span>
            </div>
            <v-spacer></v-spacer>
            <template v-if="selectedRows.length > 0">
              <v-chip color="gray" small class="mr-2">Số đơn hàng: {{ selectedRows.length }}</v-chip>
              <v-chip v-if="canViewRealPurchaseAmount" color="success" small class="mr-2">Tiền mua thật: {{selectedRows.map(item => item.TotalRealAmountCNY).reduce((prev, curr) => prev + curr, 0) | currency}}</v-chip>
              <v-chip color="gray" small class="mr-2">Tổng cân: {{selectedRows.map(item => item.OrderWeight).reduce((prev, curr) => prev + curr, 0) | currency('', 2)}}</v-chip>
              <v-chip color="success" small class="mr-2">Tổng tiền: {{selectedRows.map(item => item.TotalAmountVND).reduce((prev, curr) => prev + curr, 0) | currency}}</v-chip>
              <v-chip color="gray" small class="mr-2">Đã cọc: {{selectedRows.map(item => item.Deposit).reduce((prev, curr) => prev + curr, 0) | currency}}</v-chip>
              <v-chip color="blue" small class="mr-2">Cần cọc: {{selectedRows.map(item => item.MinDeposit).reduce((prev, curr) => prev + curr, 0) | currency}}</v-chip>
              <v-chip color="error" small class="mr-2">Còn thiếu: {{(selectedRows.map(item => item.TotalAmountVND).reduce((prev, curr) => prev + curr, 0) - selectedRows.map(item => item.Deposit).reduce((prev, curr) => prev + curr, 0)) | currency}}</v-chip>
            </template>
          </div>

          <!-- Loading bar -->
          <v-progress-linear v-if="loading" indeterminate color="blue" height="3"></v-progress-linear>

          <!-- Bảng nội bộ -->
          <v-data-table
            :headers="tableHeaders"
            :items="mappedRows"
            :must-sort="true"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="itemsPerPageProps"
            :loading="loading"
            show-select
            v-model="selectedRows"
            item-key="ID"
            class="elevation-1"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item, isSelected, select }">
              <tr :class="['oi-row', { 'oi-row--selected': isSelected }]" :active="isSelected">
                <!-- Checkbox -->
                <td class="w-check cell-check" @click="select(!isSelected)">
                  <v-checkbox
                    :input-value="isSelected"
                    hide-details
                    class="ma-0 pa-0"
                  ></v-checkbox>
                </td>

                <!-- Ảnh SP + ID + mã đơn -->
                <td class="w-product cell-product">
                  <!-- Trạng thái chip -->
                  <div class="oi-status-chip" :style="{ background: getStatusColor(item.Status) }">
                    {{ item.Status | order_status }}
                  </div>
                  <!-- Cảnh báo khiếu nại chưa xử lý -->
                  <div v-if="item.HasPendingComplain" class="oi-complain-alert">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          v-bind="attrs"
                          v-on="on"
                          x-small
                          color="deep-orange darken-2"
                          text-color="white"
                          class="oi-complain-badge font-weight-bold"
                        >
                          <v-icon x-small left>fa-exclamation-triangle</v-icon>
                          Khiếu nại ({{ item.PendingComplainCount }})
                        </v-chip>
                      </template>
                      <span>Đơn hàng đang có {{ item.PendingComplainCount }} khiếu nại chưa xử lý</span>
                    </v-tooltip>
                  </div>
                  <!-- ID link + Copy -->
                  <div class="oi-order-id-wrap d-flex align-center">
                    <a class="oi-order-id" :href="item.OrderUrl" target="_blank">{{ item.DisplayId }}</a>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="ml-1 oi-copy-btn"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop="copyDisplayId(item.DisplayId)"
                        >
                          <v-icon size="10" color="grey darken-1">fa-copy</v-icon>
                        </v-btn>
                      </template>
                      <span>Copy mã đơn</span>
                    </v-tooltip>
                  </div>
                  <!-- Ảnh -->
                  <div class="oi-img-wrap">
                    <v-img
                      v-if="item.image_origin"
                      :src="proxyImage(item.image_origin)"
                      width="85"
                      height="85"
                      class="oi-img"
                    ></v-img>
                    <div v-else class="oi-img-placeholder">No image</div>
                  </div>
                  <a
                    v-if="item.ShopID"
                    href="javascript:void(0)"
                    class="oi-shop-name"
                    @click="openShopOrders(item)"
                  >Đơn cùng shop</a>
                  <!-- Meta: số link, kho TQ -->
                  <ul class="oi-meta-list">
                    <li v-if="item.TotalLinks">{{ item.TotalLinks }} link SP</li>
                    <li v-if="item.chinaSore"><v-icon x-small>fa-store</v-icon> {{ item.chinaSore }}</li>
                  </ul>
                  <!-- Divider + chứng từ -->
                  <div v-if="item.ContractHistory && item.ContractHistory.length > 0" class="oi-divider"></div>
                  <ul v-if="item.ContractHistory && item.ContractHistory.length > 0" class="oi-contract-list">
                    <li v-for="(ct, idx) in item.ContractHistory" :key="idx" class="oi-contract-item">
                      <span class="oi-contract-type">{{ ct.type }}</span>
                      <span class="oi-contract-time">{{ ct.time ? ct.time : '—' }}</span>
                    </li>
                  </ul>
                  <!-- Dịch vụ đặc biệt -->
                  <div class="oi-flags">
                    <span v-if="item.IsFragileGoods" class="oi-flag oi-flag--wood">Đóng gỗ</span>
                    <span v-if="item.IsCheck" class="oi-flag oi-flag--check">Kiểm hàng</span>
                    <span v-if="item.GuaranteeType" class="oi-flag oi-flag--guarantee">BH</span>
                  </div>
                  <!-- Thẻ tag -->
                  <div v-if="item.Hashtags && item.Hashtags.length > 0" class="oi-hashtag-list">
                    <v-chip
                      v-for="tag in item.Hashtags"
                      :key="`${item.ID}-${tag.FlagID}`"
                      x-small
                      label
                      dark
                      class="oi-hashtag"
                      :color="tag.FlagColor"
                    >
                      {{ tag.ShortTag }}
                    </v-chip>
                  </div>
                </td>

                <!-- Lịch sử timeline -->
                <td class="w-history cell-history">
                  <ul class="oi-history-list">
                    <li
                      v-for="tl in timelineItems(item)"
                      :key="tl.key"
                      :class="['oi-history-item', { 'oi-history-item--done': !!tl.time }]"
                    >
                      <span class="oi-history-dot"></span>
                      <div class="oi-history-content">
                        <span class="oi-history-label">{{ tl.label }}</span>
                        <span v-if="tl.time" class="oi-history-time">{{ tl.time | display_date('DD/MM HH:mm') }}</span>
                        <span v-else class="oi-history-time oi-history-time--empty">—</span>
                      </div>
                    </li>
                  </ul>
                </td>

                <!-- Chi phí -->
                <td class="w-fees cell-fees">
                  <div class="oi-fee-row">
                    <span class="oi-fee-label">Tỷ giá</span>
                    <span class="oi-fee-val">{{ item.ExchangeRate | currency }}</span>
                  </div>
                  <div class="oi-fee-row">
                    <span class="oi-fee-label">Tiền hàng</span>
                    <span class="oi-fee-val">{{ item.AmountCNY | currency('¥', 2) }}</span>
                  </div>
                  <div class="oi-fee-row">
                    <span class="oi-fee-label">Ship TQ</span>
                    <span class="oi-fee-val">{{ item.FeeShipCN | currency('¥', 2) }}</span>
                  </div>
                  <div class="oi-fee-row oi-fee-row--real" v-if="canViewRealPurchaseAmount">
                    <span class="oi-fee-label">Tiền mua thật</span>
                    <span class="oi-fee-val">{{ item.TotalRealAmountCNY | currency('¥', 2) }}</span>
                  </div>
                  <div v-if="canViewPurchaseRestrictedFees" class="oi-fee-row">
                    <span class="oi-fee-label">Tiền cân</span>
                    <span class="oi-fee-val">{{ item.FeeWeightAmount | currency }}</span>
                  </div>
                 
                  <!-- Thuế / chứng từ chính ngạch -->
                  <div v-if="item.TotalInvoicePrice > 0 || item.CommissionFeeVND > 0 || item.TaxNKAmount > 0 || item.TaxVATAmount > 0 || item.TaxOtherAmount > 0 || (canViewPurchaseRestrictedFees && (item.FeeUTNK > 0 || item.Surcharge1Amount > 0 || item.Surcharge2Amount > 0))" class="oi-divider"></div>
                  <div v-if="item.TotalInvoicePrice > 0" class="oi-fee-row oi-fee-row--tax">
                    <span class="oi-fee-label">Giá trị HĐ</span>
                    <span class="oi-fee-val">{{ item.TotalInvoicePrice | currency }}</span>
                  </div>
                  <div v-if="canViewPurchaseRestrictedFees" class="oi-fee-row oi-fee-row--tax">
                    <span class="oi-fee-label">Phí UTNK</span>
                    <span class="oi-fee-val">{{ item.FeeUTNK | currency }}</span>
                  </div>
                  <div class="oi-fee-row oi-fee-row--tax">
                    <span class="oi-fee-label">Thuế NK</span>
                    <span class="oi-fee-val">{{ item.TaxNKAmount | currency }}</span>
                  </div>
                  <div class="oi-fee-row oi-fee-row--tax">
                    <span class="oi-fee-label">Thuế VAT</span>
                    <span class="oi-fee-val">{{ item.TaxVATAmount | currency }}</span>
                  </div>
                  <div v-if="item.TaxOtherAmount > 0" class="oi-fee-row oi-fee-row--tax">
                    <span class="oi-fee-label">Thuế khác</span>
                    <span class="oi-fee-val">{{ item.TaxOtherAmount | currency }}</span>
                  </div>
                  <div v-if="canViewPurchaseRestrictedFees && item.Surcharge1Amount > 0" class="oi-fee-row oi-fee-row--tax">
                    <span class="oi-fee-label">Phụ phí 1{{ item.Surcharge1Note ? ' (' + item.Surcharge1Note + ')' : '' }}</span>
                    <span class="oi-fee-val">{{ item.Surcharge1Amount | currency }}</span>
                  </div>
                  <div v-if="canViewPurchaseRestrictedFees && item.Surcharge2Amount > 0" class="oi-fee-row oi-fee-row--tax">
                    <span class="oi-fee-label">Phụ phí 2{{ item.Surcharge2Note ? ' (' + item.Surcharge2Note + ')' : '' }}</span>
                    <span class="oi-fee-val">{{ item.Surcharge2Amount | currency }}</span>
                  </div>
                  <div class="oi-fee-row oi-fee-row--total oi-divider">
                    <span class="oi-fee-label">Tổng tiền</span>
                    <span class="oi-fee-val">{{ item.TotalAmountVND | currency }}</span>
                  </div>
                  <div class="oi-fee-row oi-fee-row--deposit" v-if="saleRole || csRole">
                    <span class="oi-fee-label">DXCOC</span>
                    <span class="oi-fee-val">{{ item.MinDeposit | currency }}</span>
                  </div>
                  <div class="oi-fee-row oi-fee-row--deposit">
                    <span class="oi-fee-label">Đã cọc</span>
                    <span class="oi-fee-val">{{ item.Deposit | currency }}</span>
                  </div>
                  <div class="oi-fee-row oi-fee-row--remain">
                    <span class="oi-fee-label">Còn lại</span>
                    <span class="oi-fee-val">{{ item.RemainAmount | currency }}</span>
                  </div>
                </td>

                <!-- Nhân viên -->
                <td class="w-staff cell-staff">
                  <!-- Mua hàng -->
                  <div class="oi-staff-group">
                    <label class="oi-staff-label">Mua hàng</label>
                    <v-select
                      v-if="canEditStaff"
                      :items="p_staffs"
                      v-model="item.BuyerID"
                      item-text="FullName"
                      item-value="ID"
                      dense
                      outlined
                      hide-details
                      class="oi-staff-select"
                      @change="updateItem({OrderID: item.ID, BuyerID: item.BuyerID})"
                    ></v-select>
                    <span v-else class="oi-staff-name">{{ item.BuyerName || '—' }}</span>
                  </div>
                  <!-- CSKH -->
                  <div class="oi-staff-group">
                    <label class="oi-staff-label">CSKH</label>
                    <v-select
                      v-if="canEditStaff"
                      :items="cs_staffs"
                      v-model="item.CustomerServiceID"
                      item-text="FullName"
                      item-value="ID"
                      dense
                      outlined
                      hide-details
                      class="oi-staff-select"
                      @change="updateItem({OrderID: item.ID, CustomerServiceID: item.CustomerServiceID})"
                    ></v-select>
                    <span v-else class="oi-staff-name">{{ item.CSName || '—' }}</span>
                  </div>
                  <!-- Sale -->
                  <div class="oi-staff-group">
                    <label class="oi-staff-label">Sale</label>
                    <v-select
                      v-if="canEditStaff"
                      :items="sale_staffs"
                      v-model="item.SalerID"
                      item-text="FullName"
                      item-value="ID"
                      dense
                      outlined
                      hide-details
                      class="oi-staff-select"
                      @change="updateItem({OrderID: item.ID, SalerID: item.SalerID})"
                    ></v-select>
                    <span v-else class="oi-staff-name">{{ item.SalerName || '—' }}</span>
                  </div>
                  <!-- XNK -->
                  <div class="oi-staff-group">
                    <label class="oi-staff-label">XNK</label>
                    <v-select
                      v-if="canEditStaff"
                      :items="xnk_staffs"
                      v-model="item.OfficerID"
                      item-text="FullName"
                      item-value="ID"
                      dense
                      outlined
                      hide-details
                      class="oi-staff-select"
                      @change="updateItem({OrderID: item.ID, OfficerID: item.OfficerID})"
                    ></v-select>
                    <span v-else class="oi-staff-name">{{ item.XNKName || '—' }}</span>
                  </div>
                </td>

                <!-- Thông tin đơn -->
                <td class="w-info cell-info">
                  <!-- Trạng thái thanh toán dạng check-circle (chỉ hiển thị) -->
                  <div
                    class="oi-check-hs"
                    :class="{ 'oi-check-hs--done': item.PaymentStatus === true || item.PaymentStatus === 1 }"
                  >
                    <v-icon x-small :color="(item.PaymentStatus === true || item.PaymentStatus === 1) ? 'green' : 'grey'">
                      {{ (item.PaymentStatus === true || item.PaymentStatus === 1) ? 'fa-check-circle' : 'fa-circle' }}
                    </v-icon>
                    {{ (item.PaymentStatus === true || item.PaymentStatus === 1) ? 'Đã thanh toán' : 'Chưa thanh toán' }}
                  </div>
                  <!-- Check HS — clickable toggle thực -->
                  <div
                    class="oi-check-hs oi-check-hs--clickable"
                    :class="{ 'oi-check-hs--done': getCheckedHS(item.ID, item.IsCheckedHS === true || item.IsCheckedHS === 1) }"
                    @click="toggleCheckedHS(item.ID, item.IsCheckedHS)"
                    title="Click để chuyển trạng thái kiểm hồ sơ"
                  >
                    <v-icon x-small :color="getCheckedHS(item.ID, item.IsCheckedHS === true || item.IsCheckedHS === 1) ? 'green' : 'grey'">
                      {{ getCheckedHS(item.ID, item.IsCheckedHS === true || item.IsCheckedHS === 1) ? 'fa-check-circle' : 'fa-circle' }}
                    </v-icon>
                    Đã check HS
                  </div>
                  <!-- Xử lý CN — clickable toggle -->
                  <div
                    v-if="item.OrderType === 'NKCN'"
                    class="oi-check-hs oi-check-hs--clickable"
                    :class="{ 'oi-check-hs--done': getProcessedCN(item.ID, item.IsProcessedCN === true || item.IsProcessedCN === 1), 'oi-check-hs--fail': !(getProcessedCN(item.ID, item.IsProcessedCN === true || item.IsProcessedCN === 1)) }"
                    @click="toggleProcessedCN(item.ID, item.IsProcessedCN)"
                    title="Click để chuyển trạng thái xử lý chính ngạch"
                  >
                    <v-icon x-small :color="getProcessedCN(item.ID, item.IsProcessedCN === true || item.IsProcessedCN === 1) ? 'green' : 'red'">
                      {{ getProcessedCN(item.ID, item.IsProcessedCN === true || item.IsProcessedCN === 1) ? 'fa-check-circle' : 'fa-circle' }}
                    </v-icon>
                    Xử lý CN
                  </div>
                  <!-- Loại đơn -->
                  <div
                    class="oi-order-type"
                    :class="{ 'oi-order-type--nktn': item.OrderType === 'NKTN' }"
                  >
                    {{ item.OrderType || 'NKCN' }}
                  </div>
                  <!-- Kho VN -->
                  <div class="oi-store-name">
                    <v-icon x-small color="red">fa-warehouse</v-icon>
                    <span class="oi-store-name-text">{{ item.StoreName || 'Chưa phân kho' }}</span>
                  </div>
                  <!-- Mã đơn TQ -->
                  <div v-if="item.OrderCodeCN && !(saleRole || csRole)" class="oi-code-block">
                    <div class="oi-code-label blue--text font-weight-bold">Mã đơn TQ</div>
                    <div class="oi-code-val">
                      <span v-for="(code, i) in item.OrderCodeCN.split(';').filter(Boolean)" :key="i" class="oi-code-item font-weight-bold">
                        {{ code }}
                      </span>
                    </div>
                  </div>
                  <!-- Mã vận đơn -->
                  <div v-if="item.TransactionCode" class="oi-code-block">
                    <div class="oi-code-label">Mã vận đơn</div>
                    <div class="oi-code-val">
                      <span v-for="(code, i) in item.TransactionCode.split(';').filter(Boolean)" :key="i" class="oi-code-item">
                        {{ code }}
                      </span>
                    </div>
                  </div>
                </td>

                <!-- User -->
                <td class="w-user cell-user">
                  <a
                    v-if="adminRole"
                    class="oi-username"
                    :href="'/khach-hang/quan-ly-khach-hang/' + item.UID"
                    target="_blank"
                  >{{ item.CustomerName || item.Username }}</a>
                  <span v-else class="oi-username">{{ item.CustomerName || item.Username }}</span>
                  <div class="oi-usercode">{{ item.UserCode }}</div>
                  <div v-if="item.NoteOfCustomer" class="oi-user-note-box">{{ item.NoteOfCustomer }}</div>
                </td>

                <!-- Ghi chú Mua hàng -->
                <td class="w-note cell-note">
                  <div class="oi-note-wrapper">
                    <textarea
                      class="oi-textarea"
                      :placeholder="'Ghi chú nội bộ mua hàng…'"
                      :value="getNoteValue(item.ID, 'purchase', item.PurchaseNote)"
                      @input="setLocalNote(item.ID, 'purchase', $event.target.value)"
                      @blur="saveNote(item.ID, 'purchase', 'PurchaseNote')"
                      rows="4"
                    ></textarea>
                    <span class="oi-note-label">Mua hàng</span>
                  </div>
                </td>

                <!-- Ghi chú XNK/CSKH -->
                <td class="w-note cell-note">
                  <div class="oi-note-wrapper">
                    <textarea
                      class="oi-textarea"
                      :placeholder="'Ghi chú XNK / CSKH…'"
                      :value="getNoteValue(item.ID, 'xnk', item.XNKNote)"
                      @input="setLocalNote(item.ID, 'xnk', $event.target.value)"
                      @blur="saveNote(item.ID, 'xnk', 'XNKNote')"
                      rows="4"
                    ></textarea>
                    <span class="oi-note-label">XNK / CSKH</span>
                  </div>
                </td>

                <!-- Thao tác -->
                <td class="w-action cell-action">
                  <a :href="item.OrderUrl" target="_blank" class="oi-btn-view">
                    <v-icon small>fa-external-link-alt</v-icon> XEM ĐƠN
                  </a>
                  <a
                    href="javascript:void(0)"
                    class="oi-btn-complain"
                    :class="{ 'oi-btn-complain--has-pending': item.HasPendingComplain }"
                    @click="createComplain(item.ID)"
                    :title="item.HasPendingComplain ? `Đơn đang có ${item.PendingComplainCount} khiếu nại chưa xử lý` : 'Tạo khiếu nại'"
                  >
                    <v-icon small>fa-exclamation-circle</v-icon>
                    <span>KHIẾU NẠI</span>
                    <span v-if="item.HasPendingComplain" class="oi-btn-complain__count">({{ item.PendingComplainCount }})</span>
                  </a>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <shop-orders-popup
      v-model="dialogShopOrders"
      :shop-id="selectedShopId"
      :shop-label="selectedShopLabel"
    ></shop-orders-popup>

    <v-dialog v-model="dialogHashtagFilter" max-width="960">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="text-h6">Chọn HASHTAG để lọc</span>
          <v-btn icon @click="dialogHashtagFilter = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-0">
          <div class="oi-hashtag-popup__toolbar">
            <span class="oi-hashtag-popup__hint">
              Có thể chọn nhiều tag. Các tag được chọn sẽ lọc theo điều kiện `in`.
            </span>
            <v-btn
              text
              small
              color="error"
              :disabled="tempHashtagSelection.length === 0"
              @click="clearHashtagSelection"
            >
              Bỏ chọn tất cả
            </v-btn>
          </div>
          <div class="row">
            <v-chip
              v-for="tag in hashtagSummary"
              :key="tag.FlagID"
              clickable
              :color="tempHashtagSelection.includes(tag.FlagID) ? 'orange' : 'grey lighten-2'"
              :dark="tempHashtagSelection.includes(tag.FlagID)"
              :class="tempHashtagSelection.includes(tag.FlagID) ? 'font-bold elevation-1' : 'text-slate-700'"
              class="text-xs px-3 transition-all"
              @click="toggleTempHashtag(tag.FlagID)"
            >
              <!-- Icon tích xanh lục khi hashtag được chọn -->
              <v-icon x-small left v-if="tempHashtagSelection.includes(tag.FlagID)" color="white">fa-check</v-icon>
              {{ tag.ShortTag }}
              <span class="ml-1.5 px-1.5 py-0.2 bg-white rounded-full text-[9px] font-black text-slate-800 shadow-sm">
                {{ tag.count }} đơn
              </span>
            </v-chip>
            <!-- <div
              v-for="item in hashtagSummary"
              :key="item.FlagID"
              class="col-lg-3 col-md-4 col-sm-6 col-12 pa-0 pl-2 pr-2"
            >
              <button
                type="button"
                :style="{ 'border-left-color': item.FlagColor || '#bdc3d1' }"
                :class="{ 'active-status': isTempHashtagSelected(item.FlagID) }"
                class="oi-hashtag-summary__btn btn btn-default btn-sm btn-block"
                @click="toggleTempHashtag(item.FlagID)"
              >
                {{ item.ShortTag }}
                <span class="total">{{ item.Total }}</span>
              </button>
            </div> -->
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialogHashtagFilter = false">Hủy</v-btn>
          <v-btn color="primary" @click="applyHashtagSelection">Áp dụng</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogs from backup -->
    <v-dialog v-model="dialogExport" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Xuất file</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <div>Ngày tạo đơn</div>
              </v-flex>
              <v-flex lg6>
                <v-text-field label="Từ ngày" v-model="export_options.start_date"
                  :rules="date_validation"></v-text-field>
              </v-flex>
              <v-flex lg6>
                <v-text-field label="Đến ngày" v-model="export_options.end_date"
                  :rules="date_validation"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogExport = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="exportFile">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogNew" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="title">Tạo mới đơn hàng</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg4 md4 sm12>
                <v-autocomplete label="Khách hàng" v-model="newOrder.UID" :items="customers" item-text="Username"
                  item-value="ID"></v-autocomplete>
              </v-flex>
              <v-flex lg12 md12 sm12>
                <p class="body-2 font-weight-bold text-red">Danh sách sản phẩm</p>
                <v-list>
                  <v-list-item v-for="(item, index) in newOrder.Products" :key="item.ID">
                    <v-list-item-content>
                      <v-flex lg2 md2 sm12>
                        <v-text-field label="Link sản phẩm" v-model="item.Link"></v-text-field>
                      </v-flex>
                      <v-flex lg2 md2 sm12>
                        <img style="max-width: 56px; max-height: 56px" v-if="!hideImage"
                          v-bind:src="`${getImages(index)}`" ref="imageFile" />
                      </v-flex>
                      <v-flex lg4 md4 sm12>
                        <v-text-field label="Thuộc tính" v-model="item.Property"></v-text-field>
                      </v-flex>
                      <v-flex lg2 md2 sm12>
                        <h-currency-input label="Đơn giá (¥)" :decimal="1" v-model="item.Price"></h-currency-input>
                      </v-flex>
                      <v-flex lg2 md2 sm12>
                        <h-currency-input label="Số lượng" :decimal="0" v-model="item.Quantity"></h-currency-input>
                      </v-flex>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon @click="newOrder.Products.splice(index, 1);">
                        <v-icon>fa-trash-alt</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-layout row wrap>
                  <v-flex lg2 md2 sm12>
                    <v-text-field label="Link sản phẩm" v-model="newProduct.Link"></v-text-field>
                  </v-flex>
                  <v-flex lg2 md2 sm12>
                    <v-text-field label="Link ảnh" v-model="newProduct.Image"></v-text-field>
                  </v-flex>
                  <v-flex lg2 md2 sm12>
                    <div class="col-md-12 box-right fb flex-c text-red form-group" style="padding: 0;">
                      <div class="row">
                        <div class="col-md-4">
                          <img style="max-width: 56px; max-height: 56px" v-if="!hideImage" v-bind:src="newProduct.Image"
                            ref="imageFile" />
                        </div>
                        <div class="col-md-8">
                          <input type="file" ref="fileInput" style="display: none" @change="previewImage"
                            accept="image/*">
                          <button @click="chooseImage(newProduct)" style="cursor: point">Tải ảnh</button>
                        </div>
                      </div>
                    </div>
                  </v-flex>
                  <v-flex lg3 md3 sm12>
                    <v-text-field label="Thuộc tính" v-model="newProduct.Property"></v-text-field>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <h-currency-input label="Đơn giá (¥)" :decimal="1" v-model="newProduct.Price"></h-currency-input>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <h-currency-input label="Số lượng" :decimal="0" v-model="newProduct.Quantity"></h-currency-input>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <v-btn icon large @click="appendProduct"><v-icon color="#dc3545">far fa-plus-square</v-icon></v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogNew = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="createNewOrder">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <upload-file :dialogUpload="dialogImport" title="Import đơn hàng" temp_file="don_hang_mau.xls"
      @closePopup="dialogImport = false" @importFile="importFile"></upload-file>
    
    <v-dialog v-model="dialogUpdate" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Cập nhật đơn hàng</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <v-select v-model="selectedActionType" :items="bulkActionTypes" item-value="value" item-text="name" label="Mục cập nhật"></v-select>
              </v-flex>
              <v-flex lg12>
                <h-currency-input v-if="selectedActionType == 'ty-gia-ban' || selectedActionType == 'ty-gia-mua-vao'" label="Tỷ giá" v-model="actionValue" :decimal="0"></h-currency-input>
                <h-currency-input v-if="isSurchargeBulkAction" label="Số tiền phụ phí (VNĐ)" v-model="actionValue" :decimal="0"></h-currency-input>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogUpdate = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="multipleUpdate">Cập nhật</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogComplain" max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="title">Tạo khiếu nại</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <!-- Danh sách sản phẩm -->
              <v-flex sm12 md12 lg8>
                <div class="subtitle-1 mb-2 font-weight-bold">Danh sách sản phẩm khiếu nại</div>
                <v-data-table 
                  v-model="selectedComplainProducts"
                  :headers="complainProductHeader" 
                  :items="complainProducts" 
                  show-select
                  item-key="ID"
                  :mobile-breakpoint="100">
                  <template v-slot:item="{ item, isSelected, select }">
                    <tr>
                      <td>
                        <v-checkbox
                          :input-value="isSelected"
                          @change="select(!isSelected)"
                          hide-details
                          class="ma-0 pa-0"
                        ></v-checkbox>
                      </td>
                      <td><a target="_blank" :href="item.link_origin">{{ item.ID }}</a></td>
                      <td>
                        <img class="image-product" :src="item.image_origin && item.image_origin.includes('firebase') ? item.image_origin : decodeURIComponent(item.image_origin)" alt style="width: 64px;" />
                      </td>
                      <td>{{ item.property }}</td>
                      <td class="text-end">{{ item.quantity }}</td>
                      <td class="text-end">{{ item.price_promotion | currency('¥', 2) }}</td>
                      <td class="text-end">{{ item.quantity*item.price_promotion | currency('¥', 2) }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex sm12 md12 lg4>
                <div class="subtitle-1 mb-2 font-weight-bold">Nội dung chi tiết</div>
                <v-text-field label="Khách hàng" v-model="newComplain.Username" class="input-group--focused" disabled></v-text-field>
                <v-text-field label="Mã đơn hàng" v-model="newComplain.OrderID" class="input-group--focused" disabled></v-text-field>
                <h-currency-input v-model="newComplain.AmountNDT" :decimal="2" label="Số tiền (¥)" class="input-group--focused" @input="newComplain.Amount = newComplain.AmountNDT * newComplain.ExchangeRate"></h-currency-input>
                <h-currency-input v-model="newComplain.ExchangeRate" :decimal="0" label="Tỷ giá" class="input-group--focused" @input="newComplain.Amount = newComplain.AmountNDT * newComplain.ExchangeRate"></h-currency-input>
                <h-currency-input disabled v-model="newComplain.Amount" :decimal="0" label="Số tiền (vnđ)" class="input-group--focused"></h-currency-input>
                
                <p class="mt-3 mb-1">Nội dung khiếu nại</p>
                <v-checkbox label="Thiếu hàng" v-model="newComplain.IsMissGood" hide-details></v-checkbox>
                <v-checkbox label="Hàng bị hỏng" v-model="newComplain.IsBroken" hide-details></v-checkbox>
                <v-checkbox label="Sai tùy chọn (mầu, size)" v-model="newComplain.IsOption" hide-details></v-checkbox>
                <v-checkbox label="Khác" v-model="newComplain.IsOther" hide-details></v-checkbox>
                
                <v-textarea class="mt-3 input-group--focused" auto-grow label="Ghi chú" v-model="newComplain.ComplainText"></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogComplain = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="submitComplain">Lưu lại</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import configs from '@/configs';
import Filtering from '@/components/Filtering';
import ShopOrdersPopup from '@/components/popups/ShopOrdersPopup';
import upload_file from '@/components/popups/upload_file';
import { proxyImage, sendErrorNotice, sendSuccessNotice, makeid } from '@/commons/utils';
import { getOrderShopLabel, mapOrderToInternalRow, TIMELINE_LABELS } from '@/commons/orderInternalMapper';
import moment from 'moment';

export default {
  name: 'OrderList',

  components: {
    'hpo-filter': Filtering,
    ShopOrdersPopup,
    'upload-file': upload_file,
  },

  data() {
    return {
      proxyImage,
      pagination: {
        ...configs.PAGINATION,
        sortBy: ['ID'],
      },
      itemsPerPageProps: _.cloneDeep(configs.ITEMS_PER_PAGE),
      filterConditions: [],
      quickFilterConditions: [],
      listStatus: configs.ORDER_STATUS,
      selectedRows: [],
      localNotes: {},
      staffBuffer: {},
      checkedHSBuffer: {},
      processedCNBuffer: {},
      dialogShopOrders: false,
      selectedShopId: null,
      selectedShopLabel: 'Shop',
      dialogExport: false,
      dialogUpdate: false,
      dialogNew: false,
      dialogImport: false,
      dialogHashtagFilter: false,
      imageData: null,
      hideImage: false,
      newProduct: {
        Link: '',
        Image: '',
        Property: '',
        Price: 0,
        Quantity: 1,
      },
      newOrder: {
        UID: 0,
        Products: [],
      },
      export_options: {
        start_date: moment.utc(Date.now()).subtract(1, 'days').format(configs.SHORT_DATE_FORMAT),
        end_date: moment.utc(Date.now()).format(configs.SHORT_DATE_FORMAT),
      },
      date_validation: [v => !!v.match(/^(0?[1-9]|[12][0-9]|3[01])[\-](0?[1-9]|1[012])[\-]\d{4}$/) || 'DD-MM-YYYY'],
      tempHashtagSelection: [],
      selectedActionType: null,
      actionValue: 0,
      dialogComplain: false,
      complainProducts: [],
      selectedComplainProducts: [],
      newComplain: {
        OrderID: null,
        UID: null,
        Username: null,
        AmountNDT: 0,
        ExchangeRate: 0,
        Amount: 0,
        IsMissGood: false,
        IsBroken: false,
        IsOption: false,
        IsOther: false,
        ComplainText: '',
        Status: 1
      },
      complainProductHeader: [
        { text: "ID", value: "ID", sortable: false },
        { text: "Ảnh", value: "image_origin", sortable: false },
        { text: "Thuộc tính", value: "property", sortable: false },
        { text: "Số lượng", value: "quantity", align: "end", sortable: false },
        { text: "Giá (¥)", value: "price_promotion", align: "end", sortable: false },
        { text: "Thành tiền (¥)", value: "total", align: "end", sortable: false }
      ]
    };
  },

  computed: {
    ...mapState({
      orders: state => state.main_order.all.data,
      orderSummary: state => state.main_order.all.summary,
      total_rows: state => state.main_order.all.total,
      loading: state => state.main_order.loading,
      allFlags: state => state.flag.all.data || [],
      p_staffs: state =>
        _.filter(state.commons.all_users, o =>
          (o.RoleType & configs.ROLE_TYPE.Purchase) === configs.ROLE_TYPE.Purchase,
        ),
      cs_staffs: state =>
        _.filter(state.commons.all_users, o =>
          (o.RoleType & configs.ROLE_TYPE.CustomerService) === configs.ROLE_TYPE.CustomerService,
        ),
      sale_staffs: state =>
        _.filter(state.commons.all_users, o =>
          (o.RoleType & configs.ROLE_TYPE.Sale) === configs.ROLE_TYPE.Sale,
        ),
      xnk_staffs: state =>
       _.filter(state.commons.all_users, o =>
          (o.RoleType & configs.ROLE_TYPE.Officer) === configs.ROLE_TYPE.Officer,
        ),
      customers: state => state.customer.master.data,
      guarantees: state => {
        let tmp = [{ name: 'Không sử dụng', value: 0 }];
        if (state.feeGuarantee.all.data) {
          state.feeGuarantee.all.data.forEach(element => {
            tmp.push({ name: element.PackageName, value: element.ID });
          });
        }
        return tmp;
      },
      stores: state => {
        let tmp = [{ name: 'Chưa phân kho', value: 0 }];
        if (state.commons.stores) {
          state.commons.stores.forEach(element => {
            tmp.push({ name: element.Name, value: element.ID });
          });
        }
        return tmp;
      },
    }),

    mappedRows() {
      if (!this.orders) return [];
      return this.orders.map(o => mapOrderToInternalRow(o));
    },

    orderType() {
      const orderType = String(this.$route.meta.orderType || '').toUpperCase();
      return ['NKCN', 'NKTN'].includes(orderType) ? orderType : '';
    },

    viewName() {
      return this.orderType
        ? `order_list_internal_${this.orderType.toLowerCase()}`
        : 'order_list_internal';
    },

    hashtagSummary() {
      if (!this.orderSummary) return [];
      if (this.orderSummary.Summary && this.orderSummary.Summary.HashtagSummary) {
        return this.orderSummary.Summary.HashtagSummary;
      }
      return this.orderSummary.HashtagSummary || [];
    },

    hashtagFilterValues() {
      return _.chain(this.allFlags || [])
        .filter(item => item.ShortTag)
        .map(item => ({
          value: item.ID,
          name: item.ShortTag,
          color: item.FlagColor,
        }))
        .value();
    },

    activeHashtagIds() {
      const hashtagFilter = _.find(this.filterConditions || [], { column: 'FlagID' });
      return this.normalizeHashtagIds(hashtagFilter ? hashtagFilter.value : []);
    },

    tableHeaders() {
      return [
        { text: 'Đơn hàng', value: 'Product', sortable: false, width: '95px' },
        { text: 'Lịch sử', value: 'History', sortable: false, width: '155px' },
        { text: 'Chi phí', value: 'Fees', sortable: false, width: '195px' },
        { text: 'Nhân viên', value: 'Staff', sortable: false, width: '145px' },
        { text: 'Thông tin đơn', value: 'Info', sortable: false, width: '145px' },
        { text: 'User khách hàng', value: 'User', sortable: false, width: '140px' },
        { text: 'Ghi chú mua hàng', value: 'PurchaseNote', sortable: false, width: '155px' },
        { text: 'Ghi chú XNK/CSKH', value: 'XNKNote', sortable: false, width: '155px' },
        { text: 'Thao tác', value: 'Actions', sortable: false, width: '105px' },
      ];
    },

    filter_headers() {
      return [
        { text: 'ID', value: 'OrderCode', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Trạng thái', value: 'Status', filterable: true, dataType: configs.DATA_TYPE['Enum'], values: configs.ORDER_STATUS },
        { text: 'Mã vận đơn', value: 'TransactionCode', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Mã đơn TQ', value: 'OrderCodeCN', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Mã khách', value: 'UserCode', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Khách hàng', value: 'CustomerName', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'NV mua hàng', value: 'BuyerName', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'NV CSKH', value: 'CSName', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'NV Sale', value: 'SalerName', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'NV XNK', value: 'XNKName', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Thanh toán', value: 'PaymentStatus', filterable: true, dataType: configs.DATA_TYPE['Enum'], values: [{ value: 0, name: 'Chưa thanh toán' }, { value: 1, name: 'Đã thanh toán' }] },
        { text: 'Check HS', value: 'IsCheckedHS', filterable: true, dataType: configs.DATA_TYPE['Enum'], values: [{ value: 0, name: 'Chưa check' }, { value: 1, name: 'Đã check' }] },
        { text: 'Xử lý CN', value: 'IsProcessedCN', filterable: true, dataType: configs.DATA_TYPE['Enum'], values: [{ value: 0, name: 'Chưa xử lý' }, { value: 1, name: 'Đã xử lý' }] },
        { text: 'Loại đơn', value: 'OrderType', filterable: true, dataType: configs.DATA_TYPE['Enum'], values: [{ value: 'NKCN', name: 'NKCN' }, { value: 'NKTN', name: 'NKTN' }] },
        { text: 'Kho VN', value: 'ReceivePlaceID', filterable: true, dataType: configs.DATA_TYPE['Enum'], values: this.stores },
        { text: 'Ghi chú', value: 'Note', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Hashtag', value: 'FlagID', filterable: true, values: this.hashtagFilterValues, dataType: configs.DATA_TYPE['Enum'] },
        { text: 'Ngày tạo', value: 'CreatedDate', filterable: true, dataType: configs.DATA_TYPE['Date'] },
        { text: 'Tổng tiền', value: 'TotalAmountVND', filterable: true, dataType: configs.DATA_TYPE['Number'] },
        { text: 'Đóng gỗ', value: 'IsFragileGoods', filterable: true, values: [{ value: 0, name: 'N' }, { value: 1, name: 'Y' }], dataType: configs.DATA_TYPE['Enum'] },
        { text: 'Kiểm hàng', value: 'IsCheck', filterable: true, values: [{ value: 0, name: 'N' }, { value: 1, name: 'Y' }], dataType: configs.DATA_TYPE['Enum'] },
        { text: 'Bảo hiểm', value: 'GuaranteeType', filterable: true, values: this.guarantees, dataType: configs.DATA_TYPE['Enum'] },
      ];
    },

    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) === configs.ROLE_TYPE.Admin;
    },
    managerRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Manager) === configs.ROLE_TYPE.Manager;
    },
    paymentRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) === configs.ROLE_TYPE.Payment;
    },
    csRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) === configs.ROLE_TYPE.CustomerService;
    },
    saleRole() {
      if (this.adminRole) return false;
      const user = this.$store.state.authentication.user || {};
      const roleType = Number(user.roletype || user.RoleType || 0);
      return (roleType & configs.ROLE_TYPE.Sale) === configs.ROLE_TYPE.Sale || Number(user.IsSaleLeader || 0) === 1;
    },
    purchaseRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) === configs.ROLE_TYPE.Purchase;
    },
    canViewRealPurchaseAmount() {
      return this.adminRole || this.paymentRole || this.purchaseRole;
    },
    canViewPurchaseRestrictedFees() {
      return !this.purchaseRole || this.adminRole;
    },
    orderRole() {
      return this.$store.state.authentication.role.Orders;
    },
    canEditStaff() {
      return this.paymentRole || this.adminRole || this.buyerRole;
    },
    customerId() {
      return this.$route.query.uid ? Number(this.$route.query.uid) : 0;
    },
    isSurchargeBulkAction() {
      return ['phu-phi-1', 'phu-phi-goc-1', 'phu-phi-2', 'phu-phi-goc-2'].includes(this.selectedActionType);
    },
    bulkActionTypes() {
      let actions = [];
      if (this.saleRole) {
        actions = [
          { value: 'ty-gia-ban', name: 'Tỷ giá bán' },
          { value: 'phu-phi-1', name: 'Phụ phí 1 (VNĐ)' },
          { value: 'phu-phi-2', name: 'Phụ phí 2 (VNĐ)' },
          { value: 'da-dat-coc', name: 'Đã đặt cọc' },
        ];
      }
      else if(this.adminRole || this.paymentRole) {
        actions = [
          { value: 'ty-gia-ban', name: 'Tỷ giá bán' },
          { value: 'phu-phi-1', name: 'Phụ phí 1 (VNĐ)' },
          { value: 'phu-phi-goc-1', name: 'Phụ phí gốc 1 (VNĐ)' },
          { value: 'phu-phi-2', name: 'Phụ phí 2 (VNĐ)' },
          { value: 'phu-phi-goc-2', name: 'Phụ phí gốc 2 (VNĐ)' },
          { value: 'da-dat-coc', name: 'Đã đặt cọc' },
          { value: 'da-mua-hang', name: 'Đã mua hàng' },
        ];
        if(this.adminRole) {
          actions.splice(1, 0, { value: 'ty-gia-mua-vao', name: 'Tỷ giá mua vào' });
        }
      }
      else {
        actions = [
          { value: 'ty-gia-ban', name: 'Tỷ giá bán' },
          { value: 'phu-phi-1', name: 'Phụ phí 1 (VNĐ)' },
          { value: 'phu-phi-2', name: 'Phụ phí 2 (VNĐ)' },
          { value: 'da-dat-coc', name: 'Đã đặt cọc' },
        ];
      }
      if(!this.canViewPurchaseRestrictedFees) {
        const purchaseHiddenActions = ['phu-phi-1', 'phu-phi-goc-1', 'phu-phi-2', 'phu-phi-goc-2'];
        actions = actions.filter(item => !purchaseHiddenActions.includes(item.value));
      }
      return actions;
    },
  },

  watch: {
    pagination: {
      handler() {
        const fc = this.$store.state.commons.filterConditions;
        this.filterConditions = fc && fc[this.viewName] ? fc[this.viewName] : [];
        this.filter_data();
      },
      deep: true,
    },
    orders() {
      this.selectedRows = [];
    },
    orderType() {
      const storedFilters = this.$store.state.commons.filterConditions;
      this.filterConditions = storedFilters && storedFilters[this.viewName]
        ? _.cloneDeep(storedFilters[this.viewName])
        : [];
      this.quickFilterConditions = [];
      this.filter_data();
    },
  },

  methods: {
    copyDisplayId(displayId) {
      if (!displayId) return;
      const text = String(displayId);
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
          sendSuccessNotice(`Đã copy mã đơn: ${text}`);
        }).catch(() => {
          this.fallbackCopy(text);
        });
      } else {
        this.fallbackCopy(text);
      }
    },

    fallbackCopy(text) {
      try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        if (successful) {
          sendSuccessNotice(`Đã copy mã đơn: ${text}`);
        } else {
          sendErrorNotice('Không thể copy mã đơn!');
        }
      } catch (err) {
        sendErrorNotice('Không thể copy mã đơn!');
      }
    },

    getRequestFilters() {
      const filters = _.reject(this.filterConditions || [], { column: 'OrderType' });
      if (this.orderType) {
        filters.push({ column: 'OrderType', value: this.orderType, condition: 's_equal' });
      }
      return filters;
    },

    normalizeHashtagIds(flagIds) {
      if (_.isArray(flagIds)) {
        return _.chain(flagIds)
          .map(id => Number(id))
          .filter(id => !Number.isNaN(id))
          .uniq()
          .value();
      }

      if (_.isString(flagIds) && flagIds.length > 0) {
        return _.chain(flagIds.split(','))
          .map(id => Number(id))
          .filter(id => !Number.isNaN(id))
          .uniq()
          .value();
      }

      const singleId = Number(flagIds);
      return Number.isNaN(singleId) ? [] : [singleId];
    },

    getHashtagCondition(flagIds) {
      return {
        column: 'FlagID',
        name: 'Hashtag',
        value: this.normalizeHashtagIds(flagIds),
        menu: false,
        decimal: 0,
        dataType: configs.DATA_TYPE['Enum'],
        listOfValue: this.hashtagFilterValues,
        conditions: _.filter(configs.LIST_COMPARISON, { dataType: configs.DATA_TYPE['Enum'] }),
        selectedCondition: 'in',
      };
    },

    syncHashtagFilter(flagIds) {
      const normalizedIds = this.normalizeHashtagIds(flagIds);
      const nextFilters = _.reject(this.filterConditions || [], { column: 'FlagID' });
      const commonsFilters = _.cloneDeep(this.$store.state.commons.filters || {});
      const viewFilters = _.reject(commonsFilters[this.viewName] || [], { column: 'FlagID' });

      if (normalizedIds.length > 0) {
        nextFilters.push({
          column: 'FlagID',
          value: normalizedIds,
          condition: 'in',
        });
        viewFilters.push(this.getHashtagCondition(normalizedIds));
      }

      this.filterConditions = nextFilters;
      commonsFilters[this.viewName] = viewFilters;
      this.$store.commit('commons/setFilters', { filter: commonsFilters });

      const commonsFilterConditions = _.cloneDeep(this.$store.state.commons.filterConditions || {});
      commonsFilterConditions[this.viewName] = nextFilters;
      this.$store.commit('commons/setFilterConditions', { filter: commonsFilterConditions });
    },

    openHashtagDialog() {
      this.tempHashtagSelection = [...this.activeHashtagIds];
      this.dialogHashtagFilter = true;
    },

    isTempHashtagSelected(flagId) {
      return this.tempHashtagSelection.includes(Number(flagId));
    },

    toggleTempHashtag(flagId) {
      const normalizedId = Number(flagId);
      if (this.isTempHashtagSelected(normalizedId)) {
        this.tempHashtagSelection = this.tempHashtagSelection.filter(id => id !== normalizedId);
        return;
      }
      this.tempHashtagSelection = [...this.tempHashtagSelection, normalizedId];
    },

    clearHashtagSelection() {
      this.tempHashtagSelection = [];
    },

    applyHashtagSelection() {
      this.syncHashtagFilter(this.tempHashtagSelection);
      this.dialogHashtagFilter = false;
      this.filter_data();
    },

    filter_data() {
      const param = {
        pagination: this.pagination,
        filter: this.getRequestFilters(),
        quickFilter: this.quickFilterConditions,
      };
      if (this.customerId > 0) {
        param.uid = this.customerId;
        param.filter.push({ column: 'UID', value: this.customerId, condition: 'equal' });
      }
      this.$store.dispatch('main_order/getListOrders', param);
      this.$store.dispatch('feeGuarantee/getList');
      this.$store.dispatch('flag/getList');
      this.$store.dispatch('commons/getAllStores');
      this.getCustomerList();
    },

    applyFilter(filterConditions) {
      const { sortBy, sortDesc } = this.pagination;
      this.pagination = { ...configs.PAGINATION, sortBy, sortDesc };
      this.filterConditions = filterConditions;
      this.filter_data();
    },

    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },

    getStatusColor(status) {
      const s = configs.ORDER_STATUS.find(o => o.value === status);
      return s ? s.color : '#888';
    },

    timelineItems(row) {
      return TIMELINE_LABELS.map(tl => ({
        key: tl.key,
        label: tl.label,
        time: row[tl.key],
      }));
    },
    getShopLabel(item) {
      return getOrderShopLabel(item);
    },

    updateItem(item) {
      this.$store.dispatch('main_order/updateOrderDetail', {...item});
    },

    getCheckedHS(id, defaultValue) {
      if (this.checkedHSBuffer[id] !== undefined) {
        return this.checkedHSBuffer[id];
      }
      return defaultValue;
    },

    toggleCheckedHS(id, currentValue) {
      const newVal = !this.getCheckedHS(id, currentValue);
      this.$set(this.checkedHSBuffer, id, newVal);
      this.$store.dispatch('main_order/patchOrderFields', {
        orderId: id,
        fields: { IsCheckedHS: newVal ? 1 : 0 }
      });
    },

    getProcessedCN(id, defaultValue) {
      if (this.processedCNBuffer[id] !== undefined) {
        return this.processedCNBuffer[id];
      }
      return defaultValue;
    },

    toggleProcessedCN(id, currentValue) {
      const newVal = !this.getProcessedCN(id, currentValue);
      this.$set(this.processedCNBuffer, id, newVal);
      this.$store.dispatch('main_order/patchOrderFields', {
        orderId: id,
        fields: { IsProcessedCN: newVal ? 1 : 0 }
      });
    },

    getNoteValue(id, type, defaultValue) {
      return this.localNotes[id] && this.localNotes[id][type] !== undefined
        ? this.localNotes[id][type]
        : (defaultValue || '');
    },

    setLocalNote(id, type, value) {
      if (!this.localNotes[id]) this.$set(this.localNotes, id, {});
      this.$set(this.localNotes[id], type, value);
    },

    saveNote(id, type, dbField) {
      const order = _.find(this.orders, o => o.ID === id);
      const oldNote = (order && order[dbField]) ? order[dbField] : '';
      const note = this.getNoteValue(id, type, oldNote);
      if (note === oldNote) return; // Không thay đổi

      this.$store.dispatch('main_order/patchOrderNote', {
        orderId: id,
        field: dbField,
        value: note
      }).then(() => {
        if (order) order[dbField] = note; // Cập nhật local sau khi save thành công
      });
    },

    // Tạo khiếu nại cho đơn hàng, mở popup cho nhập thông tin để tạo khiếu nại gồm: Số tiền (Amount), Nội dung khiếu nại, Ghi chú (ComplainText), Hiển thị danh sách sản phẩm cho tích chọn sản phẩm muốn khiếu nại (tham khảo: /admin/src/views/Complain/detail.vue)
    createComplain(orderId) {
      const order = _.find(this.orders, o => o.ID === orderId);
      if (!order) return;
      this.newComplain = {
        OrderID: order.ID,
        UID: order.UID,
        Username: order.Username,
        AmountNDT: 0,
        ExchangeRate: order.ExchangeRate || 0,
        Amount: 0,
        IsMissGood: false,
        IsBroken: false,
        IsOption: false,
        IsOther: false,
        ComplainText: '',
        Status: 1
      };
      this.selectedComplainProducts = [];
      this.complainProducts = [];
      this.$store.dispatch('main_order/getOrderDetail', orderId).then((data) => {
        this.complainProducts = (data && data.data && data.data.Products) ? data.data.Products : [];
        this.dialogComplain = true;
      });
    },
    submitComplain() {
      if (!this.selectedComplainProducts || this.selectedComplainProducts.length === 0) {
        sendErrorNotice('Vui lòng chọn ít nhất 1 sản phẩm để khiếu nại.');
        return;
      }
      if (!this.newComplain.AmountNDT || this.newComplain.AmountNDT <= 0) {
        sendErrorNotice('Vui lòng nhập số tiền khiếu nại lớn hơn 0.');
        return;
      }
      if (!this.newComplain.IsMissGood && !this.newComplain.IsBroken && !this.newComplain.IsOption && !this.newComplain.IsOther) {
        sendErrorNotice('Vui lòng chọn ít nhất một nội dung khiếu nại.');
        return;
      }

      const dataToSubmit = { ...this.newComplain };
      dataToSubmit.Products = this.selectedComplainProducts.map(p => p.ID);
      this.$store.dispatch('complain/createDetail', dataToSubmit).then(() => {
        this.dialogComplain = false;
      });
    },
    openShopOrders(item) {
      if (!item || !item.ShopID) {
        return;
      }
      this.selectedShopId = item.ShopID;
      this.selectedShopLabel = this.getShopLabel(item);
      this.dialogShopOrders = true;
    },

    exportDialog() {
      this.dialogExport = true;
    },
    exportFile() {
      let param = { filter: this.getRequestFilters(), quickFilter: this.quickFilterConditions };
      if (this.customerId > 0) {
        param.filter.push({
          column: 'UID',
          value: this.customerId,
          condition: 'equal',
        });
        param.uid = this.customerId;
      }
      this.$store.dispatch('main_order/export_order', param);
    },
    getCustomerList() {
      this.$store.dispatch('customer/getCustomerList', {
        is_master: 1,
        fields: ['ID', 'Username', 'BuyerID', 'CustomerServiceID', 'ReceivePlaceID'],
      });
    },
    appendProduct() {
      this.newOrder.Products.push(this.newProduct);
      this.newProduct = {
        Link: '',
        Image: '',
        Property: '',
        Price: 0,
        Quantity: 1,
      };
    },
    createData() {
      this.dialogNew = true;
    },
    createNewOrder() {
      if (this.newOrder.Products.length === 0) {
        sendErrorNotice('Hãy nhập danh sách sản phẩm!');
        return;
      }
      if (this.newOrder.UID === 0) {
        sendErrorNotice('Hãy chọn khách hàng!');
        return;
      }
      const cust = _.find(this.customers, { ID: this.newOrder.UID });
      var param = {
        pagination: this.pagination,
        filter: this.getRequestFilters(),
        quickFilter: this.quickFilterConditions,
      };
      this.newOrder.Username = cust.Username;
      this.newOrder.BuyerID = cust.BuyerID;
      this.newOrder.CustomerServiceID = cust.CustomerServiceID;
      this.newOrder.ReceivePlaceID = cust.ReceivePlaceID;

      this.$store.dispatch('main_order/createNew', { data: this.newOrder, param: param });
      this.newOrder = {
        UID: 0,
        Products: [],
      };
      this.dialogNew = false;
      sendSuccessNotice('Tạo mới đơn hàng thành công.');
    },
    chooseImage(item) {
      this.newProduct.Image = '';
      this.$refs.fileInput.click();
    },
    previewImage(event) {
      this.imageData = event.target.files[0];
      this.$refs.fileInput.value = null;
      this.onUpload();
    },
    onUpload() {
      if (!this.imageData) return;
      let formData = new FormData();
      formData.append('file', this.imageData);

      this.$http
        .post(`${configs.API || ''}/admin/api/upload/r2/`, formData, {
          headers: { Authorization: 'Bearer ' + this.$store.state.authentication.token },
        })
        .then(res => {
          if (res.data.status === 200 && res.data.data && res.data.data.url) {
            this.newProduct.Image = res.data.data.url;
            this.hideImage = true;
            this.$nextTick(() => (this.hideImage = false));
          } else {
            sendErrorNotice('Upload thất bại: ' + (res.data.message || res.data.error || ''));
          }
        })
        .catch(err => {
          sendErrorNotice('Lỗi kết nối khi upload file.');
        });
    },
    getImages(index) {
      return this.newOrder.Products[index].Image;
    },
    importFileDialog() {
      this.dialogImport = true;
    },
    importFile(filelist) {
      for (const f of filelist) {
        const formData = new FormData();
        formData.append('excel_file', f);
        formData.append('filename', f.name);
        this.$store.dispatch('main_order/import_order', formData);
      }
      this.dialogImport = false;
    },
    multipleUpdate() {
      if (!this.adminRole && !this.managerRole && !this.paymentRole) {
        sendErrorNotice("Bạn không có quyền thực hiện chức năng này!");
        return;
      }
      if (this.selectedRows.length == 0) {
        sendErrorNotice("Hãy chọn đơn hàng muốn cập nhật!");
        return;
      }
      if (this.selectedActionType == 'ty-gia-ban' && this.actionValue <= 0) {
        sendErrorNotice("Hãy nhập tỷ giá tệ!");
        return;
      }
      if (this.selectedActionType == 'ty-gia-mua-vao' && this.actionValue <= 0) {
        sendErrorNotice("Hãy nhập tỷ giá tệ!");
        return;
      }
      if (this.selectedActionType == 'ty-gia-ban') {
        const needUpdateOrder = _.filter(this.selectedRows, (item) => { return item.Status != configs.ORDER_STATUS_ENUM.da_xuat_kho && item.Status != configs.ORDER_STATUS_ENUM.hoan_thanh; });
        if (needUpdateOrder.length == 0) {
          sendErrorNotice("Không có đơn hàng nào đủ điều kiện cập nhật!");
          return;
        }
        const ids = _.map(needUpdateOrder, 'ID');
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: ids,
          ExchangeRate: this.actionValue,
          ReCal: true
        });
      }
      else if (this.selectedActionType == 'ty-gia-mua-vao') {
        const needUpdateOrder = this.adminRole
          ? this.selectedRows
          : _.filter(this.selectedRows, (item) => { return item.Status != configs.ORDER_STATUS_ENUM.da_xuat_kho && item.Status != configs.ORDER_STATUS_ENUM.hoan_thanh; });
        if (needUpdateOrder.length == 0) {
          sendErrorNotice("Không có đơn hàng nào đủ điều kiện cập nhật!");
          return;
        }
        const ids = _.map(needUpdateOrder, 'ID');
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: ids,
          ExchangeRateBuy: this.actionValue,
          ReCal: true
        });
      }
      else if (this.isSurchargeBulkAction) {
        const canEditAllStatus = this.adminRole && (this.selectedActionType == 'phu-phi-goc-1' || this.selectedActionType == 'phu-phi-goc-2');
        const needUpdateOrder = canEditAllStatus
          ? this.selectedRows
          : _.filter(this.selectedRows, (item) => { return item.Status != configs.ORDER_STATUS_ENUM.da_xuat_kho && item.Status != configs.ORDER_STATUS_ENUM.hoan_thanh; });
        if (needUpdateOrder.length == 0) {
          sendErrorNotice("Không có đơn hàng nào đủ điều kiện cập nhật!");
          return;
        }
        const surchargeFields = {
          'phu-phi-1': 'Surcharge1Amount',
          'phu-phi-goc-1': 'Surcharge1CostAmount',
          'phu-phi-2': 'Surcharge2Amount',
          'phu-phi-goc-2': 'Surcharge2CostAmount'
        };
        const ids = _.map(needUpdateOrder, 'ID');
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: ids,
          [surchargeFields[this.selectedActionType]]: this.actionValue,
          ReCal: true
        });
      }
      else if (this.selectedActionType == 'da-dat-coc') {
        const needUpdateOrder = _.filter(this.selectedRows, (item) => { return item.Status == configs.ORDER_STATUS_ENUM.cho_dat_coc; });
        if (needUpdateOrder.length == 0) {
          sendErrorNotice("Không có đơn hàng nào đủ điều kiện cập nhật!");
          return;
        }
        const ids = _.map(needUpdateOrder, 'ID');
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: ids,
          Status: configs.ORDER_STATUS_ENUM.da_dat_coc
        });
      }
      else if (this.selectedActionType == 'da-mua-hang') {
        const needUpdateOrder = _.filter(this.selectedRows, (item) => {
          return item.Status == configs.ORDER_STATUS_ENUM.cho_mua_hang || item.Status == configs.ORDER_STATUS_ENUM.cho_tt_lan_2;
        });
        if (needUpdateOrder.length == 0) {
          sendErrorNotice("Không có đơn hàng nào đủ điều kiện cập nhật!");
          return;
        }
        const ids = _.map(needUpdateOrder, 'ID');
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: ids,
          Status: configs.ORDER_STATUS_ENUM.da_mua_hang
        });
      }

      this.dialogUpdate = false;
    },
  },

  created() {
    this.$store.dispatch('commons/getAllUsers');
    this.$store.dispatch('flag/getList');
  },

  mounted() {
    this.filterConditions = [];
    this.quickFilterConditions = [];

    // Khởi tạo bộ lọc Status từ query parameter của router nếu có
    const statusQuery = this.$route.query.status;
    if (statusQuery !== undefined && statusQuery !== null && statusQuery !== '') {
      const statusVal = Number(statusQuery);
      if (statusVal !== -1) {
        const column = _.find(this.filter_headers, { value: 'Status' });
        if (column) {
          const condition_filters = _.filter(configs.LIST_COMPARISON, { dataType: column.dataType });
          const condition = {
            column: 'Status',
            name: column.text,
            value: [statusVal],
            menu: false,
            decimal: column.decimal || 0,
            dataType: column.dataType,
            listOfValue: column.values,
            conditions: condition_filters,
            selectedCondition: condition_filters[0].value,
          };

          const commonsFilters = _.cloneDeep(this.$store.state.commons.filters || {});
          commonsFilters[this.viewName] = [condition];
          this.$store.commit('commons/setFilters', { filter: commonsFilters });

          const nextFilters = [{
            column: 'Status',
            value: [statusVal],
            condition: 'in',
          }];
          this.filterConditions = nextFilters;
          const commonsFilterConditions = _.cloneDeep(this.$store.state.commons.filterConditions || {});
          commonsFilterConditions[this.viewName] = nextFilters;
          this.$store.commit('commons/setFilterConditions', { filter: commonsFilterConditions });
        }
      }
    } else {
      // Xóa bộ lọc Status trong store nếu không có query parameter status
      const commonsFilters = _.cloneDeep(this.$store.state.commons.filters || {});
      if (commonsFilters[this.viewName]) {
        commonsFilters[this.viewName] = _.reject(commonsFilters[this.viewName], { column: 'Status' });
        this.$store.commit('commons/setFilters', { filter: commonsFilters });
      }
      const commonsFilterConditions = _.cloneDeep(this.$store.state.commons.filterConditions || {});
      if (commonsFilterConditions[this.viewName]) {
        commonsFilterConditions[this.viewName] = _.reject(commonsFilterConditions[this.viewName], { column: 'Status' });
        this.filterConditions = commonsFilterConditions[this.viewName];
        this.$store.commit('commons/setFilterConditions', { filter: commonsFilterConditions });
      }
    }

    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on('REQUEST_CREATE_DATA', this.createData);
    this.$root.$on('REQUEST_SAVE_DATA', this.exportFile);
    this.$root.$on('REQUEST_OTHER_ACTION', this.importFileDialog);
    this.$root.$on('REQUEST_REFRESH_DATA', this.filter_data);
    this.filter_data();
  },

  beforeDestroy() {
    this.$root.$off('REQUEST_CREATE_DATA', this.createData);
    this.$root.$off('REQUEST_SAVE_DATA', this.exportFile);
    this.$root.$off('REQUEST_OTHER_ACTION', this.importFileDialog);
    this.$root.$off('REQUEST_REFRESH_DATA', this.filter_data);
  },
};
</script>

<style scoped>

/* ── Scroll wrapper ─────────────────────────────────────────────── */
.oi-scroll-wrapper {
  overflow-x: auto;
  overflow-y: visible;
}

/* ── Table base ─────────────────────────────────────────────────── */
.oi-table {
  width: 100%;
  min-width: 1366px;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 15px;
}

/* Vuetify v-data-table overrides */
::v-deep .v-data-table th {
  font-size: 15px !important;
  font-weight: 700 !important;
  padding: 8px 6px !important;
}
::v-deep .v-data-table td {
  padding: 6px 6px !important;
  font-size: 14px !important;
}

/* Column widths */
::v-deep .v-data-table th:nth-child(1),
::v-deep .v-data-table td:nth-child(1),
.w-check,
.cell-check {
  width: 36px !important;
  max-width: 36px !important;
  min-width: 36px !important;
  padding: 4px !important;
}

::v-deep .v-data-table th:nth-child(2),
::v-deep .v-data-table td:nth-child(2),
.w-product,
.cell-product {
  width: 95px !important;
  max-width: 95px !important;
  min-width: 95px !important;
  padding: 4px 2px !important;
}

.w-history { width: 155px; }
.w-fees    { width: 195px; }
.w-staff   { width: 145px; }
.w-info    { width: 145px; }
.w-user    { width: 140px; }
.w-note    { width: 155px; }
.w-action  { width: 105px; }

/* ── Table header ───────────────────────────────────────────────── */
.oi-table thead tr {
  background: #0088cc;
  color: #ffffff;
}
.oi-table thead th {
  padding: 10px 5px;
  font-size: 15px;
  text-transform: uppercase;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  white-space: nowrap;
  text-align: center;
}

/* ── Table body ─────────────────────────────────────────────────── */
.oi-table tbody tr {
  border-bottom: 1px solid #e0e0e0;
  transition: background 0.15s;
}
.oi-table tbody tr:hover {
  background: #f0f7ff;
}
.oi-row--selected {
  background: #e3f2fd !important;
}
.oi-table tbody td {
  padding: 6px;
  vertical-align: top;
  border-right: 1px solid #eee;
  word-break: break-word;
}

/* ── Status chip ────────────────────────────────────────────────── */
.oi-status-chip {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 4px;
  white-space: nowrap;
}

/* ── Order ID ───────────────────────────────────────────────────── */
.oi-order-id-wrap {
  margin-bottom: 4px;
}
.oi-order-id {
  display: inline-block;
  font-weight: 700;
  font-size: 16px;
  color: #0088cc;
  text-decoration: underline;
}
.oi-copy-btn {
  opacity: 0.65;
  transition: opacity 0.2s ease;
}
.oi-copy-btn:hover {
  opacity: 1;
}

/* ── Product image ──────────────────────────────────────────────── */
.oi-img-wrap {
  margin: 4px 0;
}
.oi-img {
  border: 1px solid #ddd;
  border-radius: 3px;
}
.oi-shop-name {
  display: block;
  margin-bottom: 6px;
  color: #0088cc;
  font-size: 15px;
  font-weight: 600;
  text-decoration: underline;
}
.oi-shop-name--text {
  color: #555;
  text-decoration: none;
}
.oi-img-placeholder {
  width: 85px;
  height: 85px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #bbb;
  font-size: 13px;
  border: 1px dashed #ccc;
  border-radius: 3px;
}

/* ── Meta list ──────────────────────────────────────────────────── */
.oi-meta-list {
  margin: 4px 0 0 0;
  padding: 0 0 0 12px;
  font-size: 14px;
  color: #555;
}

/* ── Divider ────────────────────────────────────────────────────── */
.oi-divider {
  border-top: 1px solid #ddd;
  margin: 6px 0;
}

/* ── Contract list ──────────────────────────────────────────────── */
.oi-contract-list {
  padding: 0;
  margin: 0;
  list-style: none;
}
.oi-contract-item {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  padding: 1px 0;
  color: #444;
}
.oi-contract-type { font-weight: 600; }
.oi-contract-time { color: #777; }

/* ── Flags ──────────────────────────────────────────────────────── */
.oi-flags { margin-top: 4px; display: flex; flex-wrap: wrap; gap: 3px; }
.oi-flag {
  display: inline-block;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 13px;
  font-weight: 600;
}
.oi-flag--wood      { background: #795548; color: #fff; }
.oi-flag--check     { background: #0288d1; color: #fff; }
.oi-flag--guarantee { background: #388e3c; color: #fff; }

/* ── Timeline ───────────────────────────────────────────────────── */
.oi-history-list {
  padding: 0;
  margin: 0;
  list-style: none;
}
.oi-history-item {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 3px 0;
  font-size: 14px;
  color: #aaa;
}
.oi-history-item--done {
  color: #333;
}
.oi-history-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ccc;
  margin-top: 5px;
  flex-shrink: 0;
}
.oi-history-item--done .oi-history-dot {
  background: #28a745;
}
.oi-history-content { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.oi-history-label { font-weight: 600; font-size: 14px; }
.oi-history-time { font-size: 13px; color: #0088cc; }
.oi-history-time--empty { font-size: 13px; color: #bbb; }

/* ── Fees ───────────────────────────────────────────────────────── */
.oi-fee-row {
  display: flex;
  justify-content: space-between;
  padding: 1px 0;
  font-size: 14px;
}
.oi-fee-label { color: #666; }
.oi-fee-val   { font-weight: 500; color: #222; }
.oi-fee-row--total .oi-fee-label,
.oi-fee-row--total .oi-fee-val  { font-weight: 700; color: #c62828; font-size: 15px; }
.oi-fee-row--deposit .oi-fee-val { color: #2e7d32; }
.oi-fee-row--remain  .oi-fee-val { color: #e65100; }
.oi-fee-row--real .oi-fee-label,
.oi-fee-row--real .oi-fee-val { font-weight: 700; color: #1300c3; font-size: 15px;}
.oi-fee-row--tax .oi-fee-label,
.oi-fee-row--tax .oi-fee-val { font-size: 13px; color: #888; }

/* ── Staff ──────────────────────────────────────────────────────── */
.oi-staff-group {
  margin-bottom: 6px;
}
.oi-staff-group--mock .oi-staff-label { color: #aaa; }
.oi-staff-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  margin-bottom: 2px;
  text-transform: uppercase;
}
.oi-staff-name { font-size: 15px; color: #333; }
.oi-staff-select {
  font-size: 14px;
  height: 26px;
}
.oi-staff-select ::v-deep .v-input__control {
  min-height: 26px !important;
}
.oi-staff-select ::v-deep .v-input__slot {
  min-height: 26px !important;
  height: 26px !important;
  padding: 0 6px !important;
}
.oi-staff-select ::v-deep .v-select__selections {
  min-height: 26px !important;
  height: 26px !important;
  line-height: 26px !important;
  padding: 0 !important;
}
.oi-staff-select ::v-deep .v-select__selection--comma {
  margin: 0 !important;
  font-size: 14px !important;
}
.oi-staff-select ::v-deep .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center !important;
}
.oi-staff-select ::v-deep input {
  max-height: 26px !important;
  font-size: 14px !important;
}
.oi-mock-badge {
  background: #ff9800;
  color: #fff;
  border-radius: 3px;
  padding: 0 3px;
  font-size: 12px;
  font-weight: 400;
  vertical-align: middle;
}

/* ── Info cell ──────────────────────────────────────────────────── */
.oi-payment-badge {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 4px;
}
.oi-payment-badge--paid   { background: #e8f5e9; color: #2e7d32; border: 1px solid #2e7d32; }
.oi-payment-badge--unpaid { background: #fff3e0; color: #e65100; border: 1px solid #e65100; }

.oi-check-hs {
  font-size: 14px;
  color: #aaa;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.oi-check-hs--done { color: #2e7d32; }
.oi-check-hs--fail { color: #c62828; }

.oi-order-type {
  display: inline-block;
  background: #e3f2fd;
  color: #0088cc;
  border-radius: 3px;
  padding: 1px 6px;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 4px;
}
.oi-order-type--nktn {
  background: #ffebee !important;
  color: #c62828 !important;
}
.oi-store-name {
  font-size: 14px;
  color: #c62828;
  font-weight: 700;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.oi-store-name-text { font-size: 14px; }

.oi-code-block { margin-bottom: 4px; }
.oi-code-label { font-size: 13px; color: #888; }
.oi-code-val   { display: flex; flex-direction: column; }
.oi-code-item  { font-size: 14px; color: #333; font-family: monospace; }

/* ── User cell ──────────────────────────────────────────────────── */
.oi-username {
  display: block;
  font-weight: 700;
  font-size: 16px;
  color: #0088cc;
  text-decoration: none;
  margin-bottom: 2px;
}
.oi-usercode {
  font-size: 14px;
  color: #777;
  margin-bottom: 6px;
}
.oi-user-note-box {
  background: #fffde7;
  border: 1px solid #ffe082;
  border-radius: 3px;
  padding: 4px 6px;
  font-size: 14px;
  color: #555;
  margin-top: 4px;
  white-space: pre-wrap;
}

/* ── Note cell ──────────────────────────────────────────────────── */
.oi-note-wrapper {
  position: relative;
  padding-top: 14px;
}
.oi-note-label {
  position: absolute;
  top: 0;
  left: 2px;
  font-size: 12px;
  font-weight: 700;
  color: #0088cc;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.oi-textarea {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 4px 6px;
  font-size: 14px;
  font-family: inherit;
  color: #333;
  resize: vertical;
  background: #fafafa;
  transition: border-color 0.2s;
  min-height: 70px;
}
.oi-textarea:focus {
  outline: none;
  border-color: #0088cc;
  background: #fff;
}

/* ── Customer message ───────────────────────────────────────────── */
.oi-customer-msg {
  display: flex;
  gap: 4px;
  align-items: flex-start;
}
.oi-customer-msg-text {
  font-style: italic;
  font-size: 14px;
  color: #555;
  line-height: 1.5;
}

/* ── Action cell ────────────────────────────────────────────────── */
.cell-action { text-align: center; }
.oi-btn-view,
.oi-btn-complain {
  display: block;
  padding: 5px 8px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
  margin-bottom: 5px;
  cursor: pointer;
}
.oi-btn-view    { background: #0088cc; color: #fff; }
.oi-btn-view:hover { background: #0070aa; }
.oi-btn-complain { background: #e74c3c; color: #fff; }
.oi-btn-complain:hover { background: #c0392b; }
.oi-btn-complain--has-pending {
  background: #c0392b !important;
  box-shadow: 0 0 0 2px rgba(231, 76, 60, 0.4);
}
.oi-btn-complain__count {
  margin-left: 3px;
  font-weight: 800;
}
.oi-complain-alert {
  margin-bottom: 4px;
}
.oi-complain-badge {
  font-size: 11px !important;
  height: 20px !important;
  padding: 0 6px !important;
}

.oi-hashtag-summary {
  padding: 12px 16px 0 16px;
}
.oi-hashtag-summary__header {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.oi-hashtag-summary__trigger {
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  user-select: none;
}
.oi-hashtag-summary__title {
  font-size: 16px;
  font-weight: 700;
  color: #334155;
  transition: color 0.2s ease-in-out;
}
.oi-hashtag-summary__trigger:hover .oi-hashtag-summary__title {
  color: #1976d2;
}
.oi-hashtag-summary__trigger:hover .oi-hashtag-summary__arrow {
  color: #1976d2 !important;
}
.oi-hashtag-summary__arrow {
  transition: color 0.2s ease-in-out;
  display: inline-block !important;
  color: #334155 !important;
  font-size: 16px !important;
}
.oi-hashtag-summary__active {
  font-size: 15px;
  font-weight: 600;
  color: #1976d2;
}
.oi-hashtag-summary__btn {
  text-transform: uppercase !important;
  border-left: 3px solid !important;
  margin-bottom: 8px;
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  min-height: 38px;
  font-size: 14px !important;
  font-weight: 500;
  padding: 5px 10px !important;
  background-color: #ffffff !important;
  border-color: #bdc3d1 !important;
  color: #000000 !important;
  border-radius: 2px;
  text-decoration: none;
  cursor: pointer;
}
.oi-hashtag-summary__btn:hover {
  color: #696c74 !important;
  background-color: #ededed !important;
  border-color: #9fa8bc !important;
}
.oi-hashtag-summary__btn.active-status {
  color: #ffffff !important;
  background-color: #3b4354 !important;
  border-color: #3b4354 !important;
}
.oi-hashtag-summary__btn .total {
  border-left: 1px solid #bdc3d1;
  padding-left: 8px;
  margin-left: 8px;
  font-weight: bold;
  float: right;
  text-align: right;
  min-width: 20px;
}
.oi-hashtag-summary__btn.active-status .total {
  border-left-color: #ffffff;
}
.oi-hashtag-popup__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.oi-hashtag-popup__hint {
  font-size: 14px;
  color: #64748b;
}
.oi-hashtag-list {
  margin: 4px 0 0 0;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.oi-hashtag {
  font-size: 13px;
  font-weight: 600;
  color: #000000;
}

/* ── Pagination bar ─────────────────────────────────────────────── */
.oi-pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  flex-wrap: wrap;
  gap: 8px;
}
.oi-pagination-info {
  display: flex;
  align-items: center;
  font-size: 14px;
  gap: 8px;
}
.oi-per-page {
  max-width: 90px;
  font-size: 14px;
}
</style>
